/**
 * Fetch API transport strategy
 * Priority: High (preferred method)
 */

import type { TransportStrategy, TransportPayload } from './TransportStrategy.js';

export class FetchTransport implements TransportStrategy {
  name = 'fetch';
  priority = 100;

  isAvailable(): boolean {
    return typeof fetch !== 'undefined';
  }

  async send(payload: TransportPayload): Promise<void> {
    const response = await fetch(payload.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...payload.headers
      },
      body: JSON.stringify(payload.data),
      keepalive: true
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  }
}

